import $ from "jquery";

export const textareaCharacterCount = function (event) {
    const target = $(this);
    let indicator = target.parents('.form-control__textarea').find('.form-control__textarea-character-count');

    if (!indicator.length) {
        return;
    }

    const limit = target.attr('maxlength');
    const count = target.val().length

    indicator.text(`${count}/${limit}`);
    };

$(function () {
    const input = $('.form-control__textarea textarea');

    input.each(textareaCharacterCount);

    input.on('focusin', textareaCharacterCount);
    input.on('focusout', textareaCharacterCount);
    input.on('keyup', textareaCharacterCount);
    input.keypress(textareaCharacterCount);
});


